import React, { FC } from 'react';
import { SVGTooltipProps } from '@utils';
import { SvgWithTooltip } from '../SvgWithTooltip';

export const Camera: FC<SVGTooltipProps> = ({ onClick, divClassName, tooltip }) => (
  <SvgWithTooltip
    onClick={onClick}
    divClassName={divClassName}
    tooltip={tooltip}
  >
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 16 16"
    >
      <g>
        <g>
          <polygon  
            points="12,6.287 12,9.714 16,12 16,4"
          />
          <path
            d="M10,4H1C0.447,4,0,4.447,0,5v6c0,0.553,0.447,1,1,1h9c0.553,0,1-0.447,1-1v-1V9.143V6.857V6V5 C11,4.448,10.553,4,10,4z"
          />
        </g>
      </g>
    </svg>
  </SvgWithTooltip>
);
